import * as React from "react";
import * as cn from "classnames";
import "./LoadingSpinner.css";

export interface LoadingSpinnerInterface {
    className?: string;
}

export const LoadingSpinner = (props: LoadingSpinnerInterface) => (
    <div className={cn("loading-spinner", props.className)} />
);
